import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PageViewModel } from '@models/api.models';
import { BreadCrumb } from '@models/umbraco.model';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet, NgFor, NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-category-navigation',
    templateUrl: './category-navigation.component.html',
    styleUrls: ['./category-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, NgFor, NgClass, RouterLink, NgIf]
})
export class CategoryNavigationComponent {
    @Input()
    public readonly pageViewModel?: PageViewModel | null;

    @Input()
    public readonly activeId?: string;

    @Input()
    public readonly breadCrumbs?: BreadCrumb[];
}
